// frontend/src/screens/formateur/AddVideoToPlaylist.js
import React, { useState } from 'react';
import { Container, Form, Button, Alert, Card, Row, Col, Spinner } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAddVideoToPlaylistMutation } from '../../slices/playlistsApiSlice';

const AddVideoToPlaylist = () => {
  const { playlistId } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [videoFile, setVideoFile] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const [addVideoToPlaylist, { isLoading: loading }] = useAddVideoToPlaylistMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!videoFile) {
      setError('Veuillez sélectionner un fichier');
      return;
    }

    setError('');
    setMessage('');

    const formData = new FormData();
    formData.append('name', title || videoFile.name);
    formData.append('video', videoFile);

    if (description) {
      formData.append('description', description);
    }

    try {
      await addVideoToPlaylist({ playlistId, formData }).unwrap();

      setMessage('Fichier ajouté avec succès à la playlist!');
      toast.success('Fichier ajouté avec succès!');

      setTimeout(() => {
        navigate(`/formateur/playlists/${playlistId}/videos`);
      }, 2000);
    } catch (err) {
      console.error('❌ Erreur ajout fichier:', err);
      const errorMessage =
        err?.data?.error || err?.data?.message || "Erreur lors de l'ajout du fichier";
      setError(errorMessage);
      toast.error(errorMessage);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 100 * 1024 * 1024) {
        setError('Le fichier est trop volumineux (max 100MB)');
        setVideoFile(null);
        return;
      }

      setVideoFile(file);
      setError('');

      if (!title) {
        setTitle(file.name.replace(/\.[^/.]+$/, ''));
      }
    }
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow-sm">
            <Card.Header className="bg-primary text-white">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0">
                  <i className="fas fa-plus-circle me-2"></i>
                  Ajouter du contenu à la playlist
                </h4>
                <Button
                  variant="outline-light"
                  size="sm"
                  onClick={() => navigate(`/formateur/playlists/${playlistId}/videos`)}
                >
                  <i className="fas fa-arrow-left me-1"></i>
                  Retour
                </Button>
              </div>
            </Card.Header>

            <Card.Body className="p-4">
              {message && (
                <Alert variant="success">
                  <i className="fas fa-check-circle me-2"></i>
                  {message}
                </Alert>
              )}

              {error && (
                <Alert variant="danger">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  {error}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Fichier à uploader *
                    <span className="text-danger ms-1">*</span>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    accept="video/*,image/*,.pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx"
                    onChange={handleFileChange}
                    required
                    disabled={loading}
                  />
                  <Form.Text className="text-muted">
                    Types supportés: Vidéos (MP4, TS, WebM, etc.), Images (JPG, PNG,
                    etc.), PDF, PowerPoint, Word, Excel (max 100MB)
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Titre du fichier</Form.Label>
                  <Form.Control
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Donnez un titre à ce fichier..."
                    disabled={loading}
                  />
                  <Form.Text className="text-muted">
                    Laissez vide pour utiliser le nom du fichier
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Description (optionnel)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Description du contenu..."
                    disabled={loading}
                  />
                </Form.Group>

                <div className="d-flex gap-2 justify-content-end">
                  <Button
                    variant="secondary"
                    onClick={() => navigate(`/formateur/playlists/${playlistId}/videos`)}
                    disabled={loading}
                  >
                    <i className="fas fa-times me-2"></i>
                    Annuler
                  </Button>

                  <Button variant="primary" type="submit" disabled={loading || !videoFile}>
                    {loading ? (
                      <>
                        <Spinner size="sm" className="me-2" />
                        Upload en cours...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-upload me-2"></i>
                        Ajouter le fichier
                      </>
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddVideoToPlaylist;
